import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ projectName = null, customPath = null }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const generateBreadcrumbs = () => {
    if (customPath) {
      return customPath;
    }

    const path = location?.pathname;
    const breadcrumbs = [];

    // Always start with Projects
    breadcrumbs?.push({
      label: 'Stacks',
      path: '/all-projects',
      isClickable: true
    });

    if (path === '/create-project-flow') {
      breadcrumbs?.push({
        label: 'Create Stack',
        path: '/create-project-flow',
        isClickable: false
      });
    } else if (path === '/project-comparison' || path?.startsWith('/project-comparison')) {
      if (projectName) {
        breadcrumbs?.push({
          label: projectName,
          path: null,
          isClickable: false
        });
      }
      breadcrumbs?.push({
        label: 'Compare',
        path: '/project-comparison',
        isClickable: false
      });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Don't render breadcrumbs on the main projects page
  if (location?.pathname === '/all-projects' && !customPath) {
    return null;
  }

  const handleBreadcrumbClick = (path) => {
    if (path) {
      navigate(path);
    }
  };

  const truncateText = (text, maxLength = 25) => {
    if (text?.length <= maxLength) return text;
    return text?.substring(0, maxLength) + '...';
  };

  return (
    <nav className="flex items-center space-x-2 text-sm text-text-secondary mb-6" aria-label="Breadcrumb">
      {breadcrumbs?.map((crumb, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <Icon name="ChevronRight" size={16} className="text-border" />
          )}
          {crumb?.isClickable ? (
            <button
              onClick={() => handleBreadcrumbClick(crumb?.path)}
              className="hover:text-primary transition-colors duration-200 font-medium"
            >
              <span className="hidden sm:inline">{crumb?.label}</span>
              <span className="sm:hidden">{truncateText(crumb?.label, 15)}</span>
            </button>
          ) : (
            <span className="text-foreground font-medium">
              <span className="hidden sm:inline">{crumb?.label}</span>
              <span className="sm:hidden">{truncateText(crumb?.label, 15)}</span>
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;